// extracted by mini-css-extract-plugin
export default {"container":"Tda-z","heading":"Uda-z","links":"Vda-z","linkBtn":"Wda-z","disabled":"Xda-z","linkUppercaseBold":"Yda-z","copy":"Zda-z","subCopy":"_da-z"};